import { httpLink } from '@oneaudi/onegraph-client/dist/cjs/link/http-link';
import IsProdEnvironment from '~/app/utils/is-production-environment';
import { windowAvailable } from '~/utils/client-detection';

const ONEGRAPH_URL_PROD = 'https://onegraph.audi.com/graphql';
const ONEGRAPH_URL_INT = 'https://int.onegraph.audi.com/graphql';
const ONEGRAPH_URL_EOS = 'https://pre-eos.onegraph.audi.com/graphql';

export const GetHttpLink = () => {
	if (IsProdEnvironment()) return httpLink(ONEGRAPH_URL_PROD);

	const STAGE_PARAMETER = windowAvailable() ? (new URLSearchParams(window?.location.search).get('stage') ?? '') : '';
	switch (STAGE_PARAMETER) {
		case 'int':
			return httpLink(ONEGRAPH_URL_INT);
		case 'eos':
			return httpLink(ONEGRAPH_URL_EOS);
		default:
			return httpLink(ONEGRAPH_URL_PROD);
	}
};

export const ENABLE_PERSISTED_QUERIES = windowAvailable()
	? window?.localStorage?.getItem('enablePersistedQueries') !== 'false'
	: false;
if (!ENABLE_PERSISTED_QUERIES) {
	console.warn(
		"You have disabled persisted graphql queries. This is not recommended for production use. To enable, set 'enablePersistedQueries' to true in localStorage or remove it.",
	);
}
